// TranslationContext.jsx
import React, { createContext, useContext } from 'react';
import { useIntl } from 'react-intl';

const TranslationContext = createContext(null);

export const TranslationProvider = ({ children, messages }) => {
  const intl = useIntl();
  
  const t = (id, values = {}) => {
    if (!messages) return id; // no translations loaded yet

    const keys = id.split(".");
    let msg = messages;

    for (let key of keys) {
      if (!msg || !msg[key]) return id; // missing key fallback
      msg = msg[key];
    }

    return msg || id;
  };


  return (
    <TranslationContext.Provider value={t}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useT = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useT must be used inside a TranslationProvider');
  }
  return context;
};
